export const getRepoRootLabel = (repoView) => {
  if (repoView === "global") return "Global Repo";
  if (repoView === "personal") return "Personal Repo";
  if (repoView === "personal_space") return "My Personal Space";
  return "Root";
};

export const getItemLocationPath = (item, items, repoView) => {
  if (!item) return getRepoRootLabel(repoView);

  const rootLabel = getRepoRootLabel(repoView);
  const itemById = new Map(items.map((entry) => [String(entry.id), entry]));
  const segments = [];
  let parentId = item.parentId ? String(item.parentId) : null;

  while (parentId) {
    const parent = itemById.get(parentId);
    if (!parent) break;
    segments.unshift(parent.name);
    parentId = parent.parentId ? String(parent.parentId) : null;
  }

  if (segments.length === 0) return rootLabel;
  return [rootLabel, ...segments].join(" > ");
};
